import {gtagSelectedCookies} from '../inc/gtag';

const Cookies = () => {
    const querySelectors = {
        acceptCurrentSelection: document.getElementById('cookies-accept-current-selection'),
        acceptRecommended: document.getElementById('cookies-accept-recommended'),
        analyticsCookies: document.getElementById('analytical-cookies'),
        marketingCookies: document.getElementById('marketing-cookies'),
        ccc: document.getElementById('ccc'),
        cccContent: document.getElementById('ccc-content'),
        cccModule: document.getElementById('ccc-module'),
        cccOverlay: document.getElementById('ccc-overlay'),
    }

    const hideCookiePopup = () => {
        querySelectors.cccContent.style.transform = 'translateX(-100%)';
        querySelectors.cccOverlay.style.opacity = 0;
        // querySelectors.cccOverlay.style.pointerEvents = 'none';

        setTimeout(() => {
            querySelectors.cccContent.style.display = 'none';
            querySelectors.cccOverlay.style.display = 'none';
            querySelectors.cccModule.style.display = 'none';
        }, 500);
    }

    const setCookie = (name, value, days) => {
        let expires = '';

        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toUTCString();
        }

        document.cookie = name + '=' + (value || '') + expires + '; path=/';
    }

    const handleAcceptCurrentSelection = (e) => {
        hideCookiePopup();
        const analyticsAccepted = querySelectors.analyticsCookies.checked;
        const marketingAccepted = querySelectors.marketingCookies.checked;
        const optionalCookies = {};

        gtagSelectedCookies(analyticsAccepted, marketingAccepted);

        if (analyticsAccepted) {
            optionalCookies.analytics = 'accepted';
        }

        if (marketingAccepted) {
            optionalCookies.marketing = 'accepted';
        }

        setCookie('CookieControl', JSON.stringify({
            'necessaryCookies': ['__cfduid', 'DV'],
            'optionalCookies': optionalCookies,
            'statement': {'shown': true, 'updated': '26/01/2022'},
            'consentDate': 1678967326152,
            'consentExpiry': 90,
            'interactedWith': true,
            'user': '99F768FE-303B-4617-8814-75E2C614ED7E',
        }), 100);
    }

    const handleAcceptRecommended = () => {
        hideCookiePopup();
        gtagSelectedCookies(true, true);
        setCookie('CookieControl', `{"necessaryCookies":["__cfduid","DV"],"optionalCookies":{"analytics":"accepted","marketing":"accepted"},"statement":{"shown":true,"updated":"26/01/2022"},"consentDate":${Date.now()},"consentExpiry":90,"interactedWith":true,"user":"99F768FE-303B-4617-8814-75E2C614ED7E"}`, 100);
    }

    const setupListeners = () => {
        if (querySelectors.acceptCurrentSelection) {
            querySelectors.acceptCurrentSelection.addEventListener('click', handleAcceptCurrentSelection)
        }

        if (querySelectors.acceptRecommended) {
            querySelectors.acceptRecommended.addEventListener('click', handleAcceptRecommended)
        }
    }

    return {
        init: () => {
            setupListeners();
        },
    }

}

export default Cookies().init;
